import { Link } from 'react-router-dom';
import { Button } from '../../../utils/Button';

const GetApp = () => {
  return (
    <section className="grid grid-cols-1  mb-28 bg-[var(--yellow-primary)] rounded-[10px] mx-4 ">
      <div className="grid grid-cols-1 gap-14 lg:gap-6 lg:flex items-center justify-between md:px-20 px-10 lg:pt-4">
        <div className="grid gap-4 lg:gap-3  text-center lg:text-start">
          <h1 className="items-center lg:items-start text-[23px] font-semibold pt-8 lg:pt-0">
            Get the app
          </h1>{' '}
          <p className=" mx-auto lg:mx-0 mb-1">
            Own today, pay SmallSmall. One app for rent, gadgets & life’s
            essentials.
          </p>
          <div className="hidden lg:flex gap-4 justify-center lg:justify-start">
            <Link target="_blank" to="https://play.google.com/store/apps/details?id=com.smallsmallfair.app&hl=en&pli=1"
             rel="noopener noreferrer">
              <img
                role="button"
                src="/images/google-store-black.svg"
                alt="A logo incsribed with Get it on Google play"
                className="md:w-[103px] lg:w-[150px] xl:w-[182px]"
              />
            </Link>
            <Link
              target="_blank"
             rel="noopener noreferrer"
            to="https://apps.apple.com/us/app/smallsmall/id6550924061">
              <img
                role="button"
                src="/images/app-store-black.svg"
                alt="A logo incsribed with Get it on Apple store"
                className="md:w-[103px] lg:w-[150px] xl:w-[182px]"
              />
            </Link>
          </div>
          <div className="flex lg:hidden gap-4 justify-center lg:justify-start">
            <Button>
            <Link
             rel="noopener noreferrer"
            target='_blank' to="https://play.google.com/store/apps/details?id=com.smallsmallfair.app&hl=en&pli=1">
              <img
                role="button"
                src="/images/google-store-mobile.svg"
                alt="A logo incsribed with Get it on Google play"
                className="w-[103px] lg:w-[186px]"
              />
            </Link>
            </Button>
            <Button>
            <Link target='_blank'
             rel="noopener noreferrer"
            to="https://apps.apple.com/us/app/smallsmall/id6550924061">
              <img
                role="button"
                src="/images/app-store-mobile.svg"
                alt="A logo incsribed with Get it on Apple store"
                className="w-[103px] lg:w-[186px]"
              />
            </Link>
            </Button>
          </div>
        </div>
        <div className="relative">
          <div className="hidden lg:block  md:mt-[-3rem] ">
            <img
              src="/images/get-app.svg"
              alt="An image showing a phone and the payment plan"
              className="w-full object- h-full "
            />
          </div>
          <div className="block lg:hidden lg:h-[276px]">
            <img
              src="/images/iphone-14-pro.svg"
              alt="An image showing a phone and the payment plan"
              className="w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetApp;
